import React from 'react';
const frictions = ['Vuoi organizzare un’iniziativa Ottobre Rosa che abbia davvero senso, ma non hai il tempo di creare tutto da zero.', 'Cerchi idee, scarichi qualche risorsa, raccogli materiali diversi…', 'E alla fine ti ritrovi con tanti documenti separati che non formano una vera attività strutturata.'];
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-122" data-mp="2ggwzo7g6vbv3">
      <div className="mx-auto w-full max-w-3xl px-5 text-center md:px-8" data-id="element-123" data-mp="21ov5n40svd2z">
        <p className="text-xs font-extrabold uppercase tracking-widest text-pink-700" data-id="element-124" data-mp="26h67icf3p8y6">
          Il problema
        </p>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-5xl" data-id="element-125" data-mp="1sq9famp36trn">
          Hai voglia di fare qualcosa di significativo.{' '}
          <span className="bg-pink-200 px-1.5 pb-0.5 text-pink-950" data-id="element-126" data-mp="1iqiksl0j0erk">
            Ti mancano solo gli strumenti giusti.
          </span>
        </h2>

        <ul className="mt-11 space-y-4 text-left" data-id="element-127" data-mp="1npddqfs7jjpe">
          {frictions.map(item => <li key={item} className="flex items-start gap-4 border-l-4 border-amber-300 bg-stone-50 px-5 py-4 text-lg text-neutral-600 md:px-6 md:text-xl" data-id="element-128" data-mp="t8dlverzhv0j">
              {item}
            </li>)}
        </ul>

        <p className="mt-11 text-2xl font-extrabold leading-snug tracking-tight text-neutral-800 md:text-3xl" data-id="element-129" data-mp="xb0kpzn2og78">
          Un semplice volantino informa. Un’attività ben pensata può invece aprire il dialogo,
          invitare alla riflessione e creare un vero momento di condivisione.
        </p>
        <p className="mt-4 text-lg text-neutral-500" data-id="element-130" data-mp="jcaloegp06g8">
          Ottobre è già qui. Non serve ricominciare da una pagina bianca.
        </p>
      </div>
    </section>;
}